/**
 * Created by contrapro on 03/04/2018
 */

import { ACTION_TYPE_EPIC_CATCH_ERROR } from '../actions';

const initialState = {
    from: '',
    error: null
};

export default function errorReducer(state = initialState, action) {
    switch (action.type) {

        case ACTION_TYPE_EPIC_CATCH_ERROR:
            return {
                from: action.payload.from,
                error: action.payload.error
            };

        default:
            return { ...state };
    }
}



// WEBPACK FOOTER //
// ./src/reducers/errorReducer.js